import React from 'react';
import PropTypes from 'prop-types';

import Spinner from '../../../../../common/spinner/Spinner';
import { useGetPollResultsQuery } from '../../../../../../redux/services/polls';
import { useTranslation } from 'react-i18next';
import CollapseBlock from '../../../../../common/blocks/CollapseBlock/CollapseBlock.jsx';
import { capitalize } from 'lodash';
import { Pie } from 'react-chartjs-2';
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PollResultChart = ({ pollId }) => {
  const { t } = useTranslation();
  const { data: pollResults, isLoading } = useGetPollResultsQuery(pollId);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      {pollResults.map((poll, index) => {
        // Filter responses with votes > 0

        const responsesWithVotes = poll.responses
          .filter((response) => Number(response.votes) > 0)
          .slice(0, 5);

        if (responsesWithVotes.length === 0) {
          return (
            <CollapseBlock
              key={'poll-res-' + index}
              title={capitalize(t(poll.name))}
              collapsible
            >
              <p>{t('Žiadne výsledky')}</p>
            </CollapseBlock>
          );
        }

        // Prepare data for the chart
        const labels = responsesWithVotes.map((response) => response.name);
        const dataValues = responsesWithVotes.map((response) =>
          Number(response.votes),
        );
        //count everithing rom datavalues and substract form pollResults
        const otherVotes =
          poll.responseCount - dataValues.reduce((a, b) => a + b, 0);
        if (otherVotes > 0) {
          labels.push(capitalize(t('Ostatné')));
          dataValues.push(otherVotes);
        }

        // Optionally, define colors for the pie slices
        const backgroundColors = [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF',
          '#FF9F40',
          '#F2F2F2B0',
          // Add more colors if needed
        ];

        const data = {
          labels: labels,
          datasets: [
            {
              data: dataValues,
              backgroundColor: backgroundColors.slice(0, dataValues.length),
              hoverBackgroundColor: backgroundColors.slice(
                0,
                dataValues.length,
              ),
            },
          ],
        };

        const options = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'bottom',
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const value = context.parsed || 0;
                  return `${t('Počet hlasov')}: ${value}`;
                },
              },
            },
          },
        };

        return (
          <CollapseBlock
            key={'poll-res-' + index}
            title={capitalize(t(poll.name))}
            collapsible
          >
            <div style={{ height: '400px' }}>
              <Pie data={data} options={options} />
            </div>
          </CollapseBlock>
        );
      })}
    </>
  );
};

PollResultChart.propTypes = {
  pollId: PropTypes.number,
};

export default PollResultChart;
